// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-button[data-v-15a4e258]{margin-right:5px}.auth-button[data-v-15a4e258]:not(:first-of-type){margin-left:10px}.auth-button.is-circle[data-v-15a4e258]{width:36px;height:36px;padding:0;display:inline-flex;justify-content:center;align-items:center}.auth-button[data-v-15a4e258]  .el-popconfirm__main{font-size:18px;margin:8px 8px 16px 8px}", ""]);
// Exports
module.exports = exports;
